import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Main.css";
import { TextField, Button } from "@mui/material";
import { HOST_URL } from "../common";

const LoginScreen = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // 이미 로그인 된 경우 다시 캘린더 화면으로
    const url = HOST_URL + ":3002/checklogin";
    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.loggedIn) {
          navigate("/");
        }
      });
  }, [navigate]);

  const [userID, setUserID] = useState("");
  const [userPW, setUserPW] = useState("");

  const handleLogin = () => {
    // const url = 'http://localhost:3002/login?UserID=' + userID + '&UserPW=' + userPW;
    const url = HOST_URL + ":3002/login?UserID=" + userID + "&UserPW=" + userPW;
    fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          if (result.firstLogin === "true") {
            window.location.href = "/changepw";
          } else {
            window.location.href = "/";
          }
        } else if (result.code === "error") {
          window.alert(result.reason);
        }
      });
  };

  // 로그인 페이지에서 엔터를 눌러도 로그인 가능
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="Main-container">
      <div>
        <h2>KSIC 개발자 포털 로그인</h2>
        <h6>Input your login information</h6>
        <div style={{ display: "flex", flexDirection: "column", padding: 10 }}>
          <TextField
            id="filled-basic1"
            label="Input your ID"
            variant="filled"
            style={{ margin: 5, backgroundColor: "white" }}
            value={userID}
            onChange={(e) => setUserID(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <TextField
            id="filled-basic2"
            label="Input your secret code"
            variant="filled"
            style={{ margin: 5, backgroundColor: "white" }}
            value={userPW}
            onChange={(e) => setUserPW(e.target.value)}
            type="password"
            onKeyDown={onKeyDown}
          />

          <Button
            variant="contained"
            style={{ margin: 10 }}
            onClick={handleLogin}
            type="submit"
          >
            LOGIN
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
